import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { IonImg, NavController } from '@ionic/angular';
import { AuthService } from 'src/app/services/auth.service';

@Component({
  selector: 'app-welcome',
  templateUrl: './welcome.page.html',
  styleUrls: ['./welcome.page.scss'],
})
export class WelcomePage implements OnInit {
  @ViewChild('contentWrapper') contentWrapper: ElementRef<HTMLDivElement>;
  @ViewChild('particles') particles: ElementRef<HTMLImageElement>;
  activeContent = 0;
  contents = [
    {
      id: 0,
      title: 'Top Barangnya',
      desc: 'TopDepo menyediakan berbagai macam material bahan konstruksi dan bangunan untuk kebutuhan bangunan anda',
    },
    {
      id: 1,
      title: 'Top Kualitasnya',
      desc: 'TopDepo telah menjamin kualitas dari setiap produk dan material karena telah melewati tahap Quality Control',
    },
    {
      id: 2,
      title: 'Top Harganya',
      desc: 'TopDepo memberikan penawaran harga terbaik untuk kebutuhan konstruksi dan bangunan anda',
    },
  ];

  constructor(private navController: NavController, private authService: AuthService) {}

  async ngOnInit() {
    const isAuthenticated = await this.authService.isAuthenticated();

    if (isAuthenticated) {
      this.navController.navigateForward('/tabs/tabHome');
    }
  }

  navigateToLogin() {
    this.navController.navigateForward('/login');
  }

  animateContent() {
    const particleElement = this.particles.nativeElement;
    const element = this.contentWrapper.nativeElement;
    element.classList.add('appear');
    particleElement.style.transform = `rotate(calc(${this.activeContent} * ${360 / (this.contents.length + 1)}deg))`;
    // particleElement.style.rotate = `calc(${this.activeContent} * ${360 / (this.contents.length + 1)}deg)`;
    // console.log(`rotate(calc(${this.activeContent} * ${360 / (this.contents.length + 1)}deg))`);

    setTimeout(() => {
      element.classList.remove('appear');
    }, 500);
  }

  back() {
    // [style]="{rotate: 'calc(' + activeContent + '*' + 360/(contents.length + 1) +'deg' + ')'}"
    this.animateContent();
    if (this.activeContent === 0) {
      return;
    }
    this.activeContent = this.activeContent - 1;
    this.animateContent();
  }

  next() {
    this.animateContent();
    if (this.activeContent === this.contents.length - 1) {
      return;
    }
    this.activeContent = this.activeContent + 1;
    this.animateContent();
  }
}
